<!-- name: iframe 嵌入 -->
<!-- demo:
import Iframe from 'src/common/components/Iframe/index.vue';

<Iframe src='xxx'/>
 -->
<template>
  <div class="iframe-wrapper">
    <!-- 预留的头部，暂时没用到 -->
    <div v-if="isNotEmpty(title)">{{ title }}</div>
    <iframe v-if="src" ref="iframeRef" allow="clipboard-write" :src="src" :style="{ border: 0, width: '100%', height: isNotEmpty(title) ? 'calc(100% - 50px)' : '100%' }"></iframe>
    <Empty v-else/>
  </div>
</template>

<script>
import { isNotEmpty } from '@lhb/func';

export default {
  name: 'Iframe',
  props: {
    // 标题
    title: {
      type: String,
      default: null
    },
    // 链接
    src: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      PostMessageToSonType: {
        RELOAD: 'reload', // 刷新页面
        CLOSE_CONVERSATION: 'closeConversation', // 回到首页
      }
    };
  },

  mounted() {
    // 接收子级值
    window.addEventListener('message', this.getMessageForSon);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('message', this.getMessageForSon);
    });
  },

  methods: {

    isNotEmpty,

    // （提供给父级）刷新 iframe 页面
    reloadIframe() {
      console.log('reloadIframe');
      this.postMessageToSon({ type: this.PostMessageToSonType.RELOAD });
    },

    // （提供给父级）关闭会话
    closeConversation() {
      console.log('CLOSE_CONVERSATION');
      this.postMessageToSon({ type: this.PostMessageToSonType.CLOSE_CONVERSATION });
    },

    // 接收子级值消息
    async getMessageForSon(event) {
      const data = event.data || {};
      switch (data.type) {
        // 页面关闭
        case 'close':
          this.$emit('close');
          break;
      }
    },
    // 向子页面传值
    postMessageToSon({ type, data }) {
      if (!type) {
        return;
      }
      const iframe = this.$refs.iframeRef.contentWindow;
      iframe.postMessage({ type: type, data: data }, '*');
    },

  },
};
</script>

<style lang="scss" type="text/scss" scoped>
.iframe-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
